import {APP_INITIALIZER, NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ToastrModule} from 'ngx-toastr';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {DBConfig, NgxIndexedDBModule} from 'ngx-indexed-db';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {ApiService} from './shared/services/api.service';
import {RouterModule} from '@angular/router';
import {AppRoutingModule} from './app-routing.module';
import {AuthModule, LogLevel, OidcConfigService} from 'angular-auth-oidc-client';
import {LoginModule} from './login/login.module';
import {ManagementModule} from './management/management.module';
import {CommonModule} from '@angular/common';
import {ForbiddenComponent} from './Forbidden/Forbidden.component';
import {SharedModule} from './shared/module/shared.module';
import { ChatService } from './shared/services/chat.service';



export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}

export function configureAuth(oidcConfigService: OidcConfigService) {
  return () =>
    oidcConfigService.withConfig({
      stsServer: 'https://mac.medis.land',
      redirectUrl: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
      clientId: '87f710ed-526d-43fd-9770-8075b4cd1edc',
      scope: 'openid profile apiService_cd27f163-5b95-4d56-83b7-f41f597296e8 offline_access',
      // clientId: '83589cbc-5e4a-4dd3-a9d6-3ef8ab145fcd',
      // scope: 'openid profile 2d9c91c9-1393-418d-ba6f-5dca96c2f680 offline_access',
      responseType: 'code',
      silentRenew: true,
      useRefreshToken: true,
      silentRenewUrl: `${window.location.origin}/silent-renew.html`,
      // forbidden_route: '/forbidden',
      // unauthorized_route: '/unauthorized'
      // renewTimeBeforeTokenExpiresInSeconds: 10,
      //  logLevel: LogLevel.Debug,
    });
}
const dbConfig: DBConfig  = {
  name: 'Alobodo',
  version: 3,
  objectStoresMeta: [{
    store: 'Images',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: [
      { name: 'MD5', keypath: 'MD5', options: { unique: false } },
      { name: 'icon', keypath: 'icon', options: { unique: false } }]
  }]
};



@NgModule({
  declarations: [
    AppComponent,
    ForbiddenComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CommonModule,
    HttpClientModule,
    LoginModule,
    ManagementModule,
    BrowserAnimationsModule, // required animations module
    NgbModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production, scope: '/',
      registrationStrategy: 'registerImmediately'
    }),
    NgxIndexedDBModule.forRoot(dbConfig),
    ToastrModule.forRoot(),
    RouterModule,
    AuthModule.forRoot(),
    BrowserAnimationsModule,
    SharedModule
  ],
  providers: [ApiService,
    ChatService,
    OidcConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: configureAuth,
      deps: [OidcConfigService],
      multi: true,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
